export const oneDay = 60 * 60 * 24 * 1000;
